
import { PageQuery } from '@/mixins/page_query';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { iGamDiscusstionModel, iGameDiscusstionQuery, iGamMarkingModel } from '@/interface/game-discussion-manage';
import { getGameForum, getForumSetting, UpdateForumSetting, getGameForumByGameID, delGorum, getGameForumByGameIDAndId } from '@/api/game-discusstion-manage';
import { toast } from '@/utils/common';
import moment from 'moment';
import Detail from '../discussion-detail/index.vue';
@Component({
  components: { Detail },
})
export default class GameMarking extends Mixins(PageQuery) {
  @Prop() detailInfo!: iGamMarkingModel;
  @Prop() searchData!: any;
  discussable = true;
  loading: boolean = false;
  private start!: any;
  private end!: any;
  private visible: boolean = false;
  gameDesc: string = '';

  private detailDiscussionInfo: iGamDiscusstionModel = {
    id: 0,
    content: '',
    game_id: 0,
    game_name: '',
    user: {
      id: 0,
      nickname: '0',
      headimgurl: '0',
    },
    created_at: 0,
    score: 0,
  };
  private query: iGameDiscusstionQuery = {
    start_time: null,
    end_time: null,
    content_keywords: '',
    nickname: '',
    uid: null,
    game_id: null,
    game_name: '',
  };
  dateHandler(e: any) {
    this.start = moment(e[0], 'YYYY-MM-DD').unix();
    this.end = moment(e[1])
      .endOf('day')
      .unix();
  }
  private dates: (string | Date)[] = [];
  tableData: iGamDiscusstionModel[] = [];
  ids: number[] = [];
  search() {
    this.page_query.page = 1;
    this.getSearchList();
  }

  async getSearchList() {
    try {
      this.loading = true;
      this.query.start_time = this.start;
      this.query.end_time = this.end;
      const param = { ...this.page_query, ...this.query };
      const res = await getGameForumByGameID(param);
      this.tableData = res.data.rows;
      this.total = res.data.total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  goback() {
    this.$emit('goBackMarking');
  }
  handleSelectionChange(val: any) {
    this.ids = val.map((item: any) => {
      return item.id;
    });
  }
  /* 行选择*/
  toggleSelection(rows: any, column: any) {
    try {
      if (column.label != '操作') {
        (this.$refs['selectTableDate'] as any).toggleRowSelection(rows);
      }
    } catch {}
  }
  async editRow(row: iGamDiscusstionModel) {
    this.visible = true;
    const res: any = await getGameForumByGameIDAndId(row.game_id, row.id);
    this.detailDiscussionInfo = res.data;
  }
  handleDeleteBatch() {
    this.delGorum();
  }
  handleDeleteRow(row: iGamDiscusstionModel) {
    this.ids = [row.id];
    this.delGorum();
  }
  async delGorum() {
    if (this.ids.length < 1) {
      toast('请选择需要删除的条目!', 'error');
      return;
    }
    this.$msgbox({
      title: '提示',
      message: '删除后，不可恢复，确认删除吗？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          done();
          const res: any = await delGorum(this.ids, this.detailInfo.game_id);
          const { msg, code } = res;
          if (code == 0) {
            toast('删除成功!');
            this.getSearchList();
            this.ids = [];
          } else {
            toast(msg, 'error');
          }
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          //    alert(action);
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  handelClose() {
    this.visible = false;
  }
  mounted() {
    const { content_keywords, game_id, game_name } = this.searchData;
    this.query.content_keywords = content_keywords;
    this.query.game_id = game_id;
    this.query.game_name = game_name;
    if (game_name && game_id) {
      this.gameDesc = game_name + '-' + game_id;
    } else {
      if (game_name) {
        this.gameDesc = game_name;
      } else if (game_id) {
        this.gameDesc = game_id;
      }
    }
    this.pageFn = this.getSearchList;
    this.getSearchList();
  }
}
